import select from 'dom-select'
import on from 'dom-event'

class HalfCols {
  constructor (el) {
    this.el = el
    this.cols = select.all('[data-col]', this.el)
    if (this.cols) {
      this.cols = Array.from(this.cols)
    }
    this.setImagePosition = this.setImagePosition.bind(this)
    on(window, 'resize', this.setImagePosition)
    this.setImagePosition()
  }

  setImagePosition () {
    this.cols.forEach((col) => {
      const image = select('[data-col-image]', col)
      const content = select('[data-col-content]', col)
      if (image && content) {
        const { height } = image.getBoundingClientRect()
        content.style.marginTop = `-${height / 2}px`
        content.style.paddingTop = `${height / 2}px`
      }
    })
  }
}
export default (el) => new HalfCols(el)
